import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { Field } from "react-final-form";

import BodyText from "Common/BodyText";
import SIFormLabel from "Common/forms/SIFormLabel";
import { Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { Input as ThemeInput } from "Theme/Input";

import makeBem from "Utils/makeBem";

const bem = makeBem("SIFormField");
// Will most likely move Col out of SIFInalFormField and
// make a new component that's like Page.Question that contains
// the Col + FormField.  Makes no sense to put the Col here which
// will create spacing and depends on Row/Grid
export const SIFinalFormFieldNoCol = (props) => {
  const { name, component, label, validate, id, componentProps, type, hideErrorText, parse, format, guidance, autoFocus, noBounce, errorRight } = props;

  // Used only to turn the label red when erroring for intuit.
  const status = (meta) => {
    const { touched, error, submitError } = meta;
    let returnVal;

    if (!touched) {
      returnVal = "untouched";
    } else if (error || submitError) {
      returnVal = "error";
    } else {
      returnVal = "valid";
    }

    return returnVal;
  };

  const renderError = (meta, noBounce) => (
    <BodyText className={classnames(bem("Validation"), bem("Validation", status(meta)), noBounce ? bem("Validation", "noBounce") : "")}>
      {meta.error || meta.submitError} &nbsp;
    </BodyText>
  );

  const showErrorText = (meta) => !hideErrorText && (meta.error || meta.submitError) && meta.touched;

  const inputId = id || name;
  return (
    <Field name={name} validate={validate} type={type} parse={parse} format={format}>
      {({ input, meta }) => (
        <Div className={errorRight ? bem("LabelWrapper", "errorRight") : bem("LabelWrapper")}>
          {label && <SIFormLabel label={label} status={status(meta)} htmlFor={inputId} guidance={guidance} />}
          <Div className={errorRight ? bem("ElementWrapper", "errorRight") : bem("ElementWrapper")}>
            {React.createElement(component, {
              id: inputId,
              input,
              meta,
              autoFocus,
              errorRight,
              ...componentProps,
            })}
            {noBounce || showErrorText(meta) ? renderError(meta) : null}
          </Div>
        </Div>
      )}
    </Field>
  );
};
export default class SIFinalFormField extends React.Component {
  static defaultProps = {
    component: ThemeInput,
  };

  render() {
    const {
      name,
      component,
      label,
      validate,
      id,
      componentProps,
      type,
      hideErrorText,
      parse,
      format,
      guidance,
      autoFocus,
      noBounce,
      errorRight,
      ...rest // Used to pass in responsive size controls (e.g sm, lg, etc)
    } = this.props;
    const mb = this.props.mb || (isIntuit() ? 3 : 4);
    return (
      <Col mb={mb} {...rest}>
        <SIFinalFormFieldNoCol
          name={name}
          component={component}
          label={label}
          validate={validate}
          id={id}
          type={type}
          componentProps={componentProps}
          hideErrorText={hideErrorText}
          parse={parse}
          format={format}
          guidance={guidance}
          autoFocus={autoFocus}
          noBounce={noBounce}
          errorRight={errorRight}
        />
      </Col>
    );
  }
}
